import { useRef, useState } from "react";
import { useImportVenmo } from "../api/venmo";

export function VenmoImport() {
  const importer = useImportVenmo();
  const inputRef = useRef<HTMLInputElement>(null);
  const [msg, setMsg] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const onFile = async (file: File) => {
    setMsg(null);
    setError(null);
    const text = await file.text();
    try {
      const r = await importer.mutateAsync(text);
      setMsg(
        `Imported ${r.imported} of ${r.parsed} transaction(s)` +
          (r.duplicates ? `, ${r.duplicates} already present.` : "."),
      );
    } catch (err) {
      setError(friendly(String((err as Error).message)));
    }
    if (inputRef.current) inputRef.current.value = "";
  };

  return (
    <div className="rounded-lg border border-slate-800 bg-slate-900/40 p-4 flex items-start justify-between gap-4">
      <div className="text-sm">
        <div className="font-medium">Venmo import</div>
        <p className="text-slate-400 mt-1">
          Monthly: export your statement CSV from Venmo and upload it here. New
          transactions are deduped and categorized automatically.
        </p>
        {msg && <div className="text-emerald-400 text-xs mt-2">{msg}</div>}
        {error && <div className="text-rose-400 text-xs mt-2">{error}</div>}
      </div>
      <div>
        <input
          ref={inputRef}
          type="file"
          accept=".csv,text/csv"
          className="hidden"
          onChange={(e) => {
            const f = e.target.files?.[0];
            if (f) void onFile(f);
          }}
        />
        <button
          onClick={() => inputRef.current?.click()}
          disabled={importer.isPending}
          className="rounded bg-blue-600 hover:bg-blue-500 disabled:opacity-50 text-sm font-medium px-4 py-2 transition whitespace-nowrap"
        >
          {importer.isPending ? "Importing…" : "Upload CSV"}
        </button>
      </div>
    </div>
  );
}

function friendly(error: string): string {
  if (error.includes("no_transactions_found"))
    return "No transactions found — is this a Venmo statement CSV?";
  if (error.includes("empty_csv")) return "That file looks empty.";
  if (error.includes("csv_too_large")) return "That file is too large.";
  if (error.includes("parse_failed")) return "Couldn't parse that CSV.";
  return "Import failed. Try again.";
}
